import BaseComponent from "mam-core-react/dist/modules/baseComponent/baseComponent";

export default BaseComponent